import { mediaQuery } from 'lib/styles/media'
// lib
import * as styles from 'lib/styles/styles'
import styled from 'styled-components'

const Logo = () => {
	return (
		<Wrapper href="http://boighor.com.bd/" target="__blank__">
			<Img src="/images/logo.png" alt="Logo" />
		</Wrapper>
	);
}

const Wrapper = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	outline: none;
	margin-left: 16px;
	background-color: rgba(0,0,0,0);
	transition: .2s ${styles.transition};
	border-radius: 8px;
	padding: 4px 8px;
	cursor: pointer;

	${mediaQuery(700)} {
		display: none;
	}

	
`;

const Img = styled.img`
	height: 44px;
`;

export default Logo